import { useMutation, useQueryClient } from '@tanstack/vue-query'
import Student from '@/api/Dara/Student'
import { studentKeys } from '@/composable/queries/keys'

export const useSwitchStudentMutation = () => {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: (studentId: number) => Student.setCurrentStudent(studentId),
    onSuccess: (data, studentId: number) => {
      queryClient.invalidateQueries({
        queryKey: studentKeys.student(ref(studentId))
      })
    },
  })
}

export const useStudentSettingsMutation = (
  studentId: Ref<number>,
) => {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: (settings: Domain.Students.ValueObjects.StudentSettings) => Student.updateStudentSettings(studentId.value, settings),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: studentKeys.settings(studentId)
      })
    },
  })
}

export const useUpdateGroupsMutation = (
  studentId: Ref<number>,
) => {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: (data: { year_group_id: number, year_sub_group_id?: number }) => {
      const payload: any = { year_group_id: data.year_group_id }
      if (data.year_sub_group_id !== undefined) {
        payload.year_sub_group_id = data.year_sub_group_id
      }
      return Student.updateGroups(studentId.value, payload)
    },
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: studentKeys.student(studentId)
      })
    },
  })
}
